import React from 'react';
//MUI
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TableFooter from '@mui/material/TableFooter';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import MuiTablePagination from '@mui/material/TablePagination';
import Typography from '@mui/material/Typography';
import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
   container: {
      marginTop: theme.spacing(2),
      width: '95%'
   },
   legend: {
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(2)
   },
   legendItem: {
      display: 'flex',
      alignItems: 'normal',
      marginRight: theme.spacing(2)
   },
   legendColor: {
      width: '20px',
      height: '20px',
      marginRight: theme.spacing(1),
      borderRadius: '50px'
   },
   red: {
      backgroundColor: theme.palette.error.main
   },
   blue: {
      backgroundColor: theme.palette.info.main
   },
   green: {
      backgroundColor: theme.palette.success.main
   }
}));
function Footer({count, page, rowsPerPage, changeRowsPerPage, changePage}) {
   const {classes, cx} = useStyles();
   function handleRowChange(event) {
      changeRowsPerPage(parseInt(event.target.value, 10));
   }

   function handlePageChange(_, page) {
      changePage(page);
   }

   return (
      <>
         <TableFooter>
            <TableRow>
               <TableCell style={{display: 'flex'}}>
                  <Grid container className={classes.legend}>
                     <Grid item className={classes.legendItem}>
                        <Box sx={[classes.legendColor, classes.blue]} />
                        <Typography>Nueva llave</Typography>
                     </Grid>
                     <Grid item className={classes.legendItem}>
                        <Box sx={[classes.legendColor, classes.green]} />
                        <Typography>Llave vigente</Typography>
                     </Grid>
                     <Grid item className={classes.legendItem}>
                        <Box className={cx(classes.legendColor, classes.red)} />
                        <Typography>Llave dada de baja</Typography>
                     </Grid>
                  </Grid>
               </TableCell>
               <TableCell>
                  <MuiTablePagination
                     component="div"
                     count={count}
                     rowsPerPage={rowsPerPage}
                     page={page}
                     labelRowsPerPage="Filas por página:"
                     labelDisplayedRows={({from, to, count}) => `${from}-${to} de ${count}`}
                     slotProps={{
                        actions: {
                           backIconButtonProps: {'aria-label': 'Anterior página'},
                           nextIconButtonProps: {'aria-label': 'Siguiente página'}
                        }
                     }}
                     rowsPerPageOptions={[5, 10, 15, 100]}
                     onPageChange={handlePageChange}
                     onRowsPerPageChange={handleRowChange}
                  />
               </TableCell>
            </TableRow>
         </TableFooter>
      </>
   );
}

export default Footer;
